<template>
    <div class="row" v-loading="isLoading">
        <div class="col-sm-12">
            <h1 v-if="isGlobalPage">Leads</h1>
            <slot/>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isGlobalPage: { type: Boolean, required: true },
            isLoading: { type: Boolean, required: false, default: false },
        },
    };
</script>
